import certificateImage from 'bundles/front-page/redesign-modules/merchandising-buckets/assets/Certificate.svg';
import graduationCapImage from 'bundles/front-page/redesign-modules/merchandising-buckets/assets/GraduationCap.svg';
import unionImage from 'bundles/front-page/redesign-modules/merchandising-buckets/assets/Union.svg';

import _t from 'i18n!nls/front-page';

const getMerchandisingBuckets = () => {
  return [
    {
      title: _t('Launch a new career'),
      linkTo: '/career-academy',
      image: unionImage,
    },
    {
      title: _t('Gain in-demand skills'),
      linkTo: '/browse',
      image: certificateImage,
    },
    {
      title: _t('Earn a degree'),
      linkTo: '/degrees',
      image: graduationCapImage,
    },
  ];
};

export default getMerchandisingBuckets;
